import { Directive, ElementRef, inject, OnInit } from '@angular/core';

@Directive({
    selector: '[inputFieldBuilderAutoFocus]',
    standalone: false
})
export class InputAutoFocusDirective implements OnInit {
  private readonly input = inject(ElementRef);

  public ngOnInit(): void {
    setTimeout(() => {
      this.input.nativeElement.focus();
    });
  }

}
